
export default {
  orsDictionary: {
    unknown: 'Unbekannt',
    paved: 'Befestigt',
    unpaved: 'Unbefestigt',
    asphalt: 'Asphalt',
    concrete: 'Beton',
    cobblestone: 'Kopfsteinpflaster',
    metal: 'Metall',
    wood: 'Holz',
    compactedGravel: 'Verdichteter Schotter',
    fineGravel: 'Feiner Schotter',
    gravel: 'Schotter',
    dirt: 'Erde',
    ground: 'Boden',
    ice: 'Eis',
    pavingStones: 'Pflastersteine',
    sand: 'Sand',
    woodchips: 'Hackschnitzel',
    grass: 'Gras',
    grassPaver: 'Rasengittersteine',
    none: 'Kein',
    no: 'Nein',
    customers: 'Kundenzugang',
    destination: 'Anlieger frei',
    delivery: 'Lieferverkehr',
    private: 'Privat',
    permissive: 'Geduldet',
    permit: 'Mit Erlaubnis',
    stateRoad: 'Bundesstraße',
    road: 'Landstraße',
    street: 'Straße',
    path: 'Weg',
    track: 'Pfad',
    cycleway: 'Radweg',
    footway: 'Fußweg/Gehweg',
    steps: 'Stufen',
    ferry: 'Fähre',
    construction: 'Im Bau',
    'concrete:lanes': 'Plattenweg',
    paving_stones: 'Pflastersteine',
    sett: 'Behauenes Steinpflaster',
    unhewn_cobblestone: 'Rohes Kopfsteinpflaster',
    compacted: 'Verdichtet',
    fine_gravel: 'Feiner Schotte',
    pebblestone: 'Kieselsteine',
    impassable: 'Nicht passierbar',
    very_horrible: 'Sehr schrecklich',
    horrible: 'Schrecklich',
    very_bad: 'Sehr schlecht',
    bad: 'Schlecht',
    intermediate: 'Mittel',
    good: 'Gut',
    excellent: 'Ausgezeichnet',
    grade1: 'Wasserfester Belag',
    grade2: 'Wassergebundene Decke',
    grade3: 'Befestigter oder ausgebesserter Weg',
    grade4: 'Einfacher Weg',
    grade5: 'Unbefestigter Weg',
    no_tollway: 'Keine Mautstraße',
    is_tollway: 'Ist mautpflichtig',
    no_category: 'Keine Kategorie',
    highway: 'Autobahn',
    unpaved_road: 'Nicht befestigte Straße',
    tunnel:	'Tunnel',
    paved_road:	'Befestigte Straße',
    ford: 'Furt',
    no_data: 'Keine Daten',
    low: 'Niedrig',
    moderate: 'Mittel',
    high: 'Hoch'
  }
}
